<template>
  <div class="ren-decoration-cp ren-decoration-cp-action-card">
    <div>
      <strong>{{ title }}</strong>
      <span>{{ emptyText }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const title = computed(() => stringValue(props.component.props?.title, '消息中心'))
const emptyText = computed(() => stringValue(props.component.props?.emptyText, '暂时没有新消息'))
</script>
